import { ThemeColors } from "consts/theme";
import React from "react";

interface PaziaStatusLabelProps {
  children: React.ReactNode;
  color: ThemeColors;
  size?: "xs" | "sm";
}

const colorClasses: Record<ThemeColors, string> = {
  slate: "text-slate-500 dark:text-slate-400",
  primary: "text-primary-500 dark:text-primary-400",
  indigo: "text-indigo-500 dark:text-indigo-400",
  emerald: "text-emerald-500 dark:text-emerald-400",
  amber: "text-amber-500 dark:text-amber-400",
  white: "text-white dark:text-slate-100",
};
export const PaziaStatusLabel = ({ children, color, size = "sm" }: PaziaStatusLabelProps): JSX.Element => {
  return (
    <div className="flex items-center">
      <svg className={`w-3 h-3 shrink-0 fill-current ${colorClasses[color]} mr-3`} viewBox="0 0 12 12">
        <path d="M6 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2A6 6 0 1 1 6 0a6 6 0 0 1 0 12Z" />
      </svg>
      <span className={`${sizeClasses[size]} font-medium text-slate-600 dark:text-slate-300`}>{children}</span>
    </div>
  );
};

const sizeClasses = {
  xs: "text-xs",
  sm: "text-sm",
};
